import { createAndRedirectToNewApp } from '../../../common/components/utility';

export class WhySnappiiAppBuilder {
    store = null;

    async init({ store }) {
        this.store = store;
        await this._initActions();
    }

    async _initActions() {
        const enterAppBuilderButton: HTMLButtonElement = document.querySelector('.why-snappii-app-builder-action-control--app-builder');

        if (enterAppBuilderButton !== null) {        
            enterAppBuilderButton.addEventListener('click', async (event) => {
                const createAndRedirectToNewAppOptions = {
                    store: this.store
                }

                await createAndRedirectToNewApp(createAndRedirectToNewAppOptions);
            })
        }
    }
}